import { useCallback } from 'react';
import { DateTime, DateTimeService, useLocalizedDayShortNames } from '@mews/framework';

export const useLocalizeDayShortName = () => {
    const dayNames = useLocalizedDayShortNames();

    return useCallback(
        (date: DateTime) => {
            const day = DateTimeService.getDay(date);
            return dayNames[day];
        },
        [dayNames]
    );
};
